import React from 'react';
import IconType from './iconType';

function TickIcon({ color = '#BDBDBD', width = 12, height = 12, ...rest }: IconType) {
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M2.0625 6.5625L4.6875 9.1875L9.9375 3.5625"
        stroke={color}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default TickIcon;
